export default __webpack_public_path__ + "static/media/033-mountain.dd1b5662.svg";